export default "__VITE_ASSET__CAz4I6rt__"